import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { ProviderTable } from './table';

export function ProvidersTab({ importTypeId, importTypeName }: TabProps) {
	return (
		<TabsContent value="providers">
			<Card>
				<CardHeader>
					<CardTitle>Providers</CardTitle>
					<CardDescription>
						Provider Mappings for {importTypeName} - {importTypeId}
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<ProviderTable importTypeId={importTypeId} />
				</CardContent>
			</Card>
		</TabsContent>
	);
}
